import Common from './Common';

export default class LastSearch {
    static get() {
        return Common.request({
            url: '/v1/search/last?version=2&limit=1'
        }).then((results) => {
            if (Array.isArray(results) && results.length > 0) {
                return results[0];
            }
            return null;
        });
    }
}
